import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onLoading", "onComplete", "untilComplete", "isLoading", "isComplete", "isProcessing", "children", "partNumber", "dispatch"];
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { flatten } from '../../helpers';
export var Feedback = function Feedback(_ref) {
  var onLoading = _ref.onLoading,
      onComplete = _ref.onComplete,
      untilComplete = _ref.untilComplete,
      isLoading = _ref.isLoading,
      isComplete = _ref.isComplete,
      isProcessing = _ref.isProcessing,
      children = _ref.children,
      partNumber = _ref.partNumber,
      dispatch = _ref.dispatch,
      props = _objectWithoutProperties(_ref, _excluded);

  return (onLoading && isLoading || onComplete && isComplete || untilComplete && !isComplete) && /*#__PURE__*/React.createElement("span", props, children);
};
Feedback.propTypes = {
  partNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onLoading: PropTypes.bool,
  onComplete: PropTypes.bool,
  untilComplete: PropTypes.bool
};
Feedback.defaultProps = {
  onLoading: false,
  onComplete: false,
  untilComplete: false
};

var mapStateToProps = function mapStateToProps(state, props) {
  var _ref2 = flatten(state).trolleyItems || {
    added: [],
    inProgress: []
  },
      added = _ref2.added,
      inProgress = _ref2.inProgress,
      isProcessing = _ref2.isProcessing;

  return {
    isLoading: inProgress.includes(props.partNumber),
    isComplete: added.includes(props.partNumber),
    isProcessing: isProcessing
  };
};

export default connect(mapStateToProps)(Feedback);